// extracted by mini-css-extract-plugin
export default {"btnReset":"Button_btnReset__YKTyT","customButton":"Button_customButton__QifFx","customButtonDisabled":"Button_customButtonDisabled__e71kr","whiteButton":"Button_whiteButton__swrOw"};